import { useQuery } from '@tanstack/react-query';
import { getSourcingEvents } from '../api';

export function useSourcingEvents() {
  return useQuery({
    queryKey: ['sourcing-events'],
    queryFn: getSourcingEvents,
    // Refresh for live auctions
    refetchInterval: 10000,
  });
}
